import {
  types,
  IPublishedGraphic,
  IGetPublishedGraphicAction,
  IGetPublishedGraphicSuccessAction,
  IFailureAction,
} from '../types/publishedGraphic'

export const getPublishedGraphicById = (
  id: string
): IGetPublishedGraphicAction => ({
  type: types.GET_PUBLISHED_GRAPHIC_BY_ID__STARTED,
  id,
})

export const getPublishedGraphicByIdSuccess = (
  publishedGraphicData: IPublishedGraphic
): IGetPublishedGraphicSuccessAction => ({
  type: types.GET_PUBLISHED_GRAPHIC_BY_ID__SUCCESS,
  publishedGraphicData,
})

export const getPublishedGraphicByIdFailure = (
  message: string
): IFailureAction => ({
  type: types.GET_PUBLISHED_GRAPHIC_BY_ID__FAILURE,
  message,
})
